export default __webpack_public_path__ + "static/media/expandArrow.a388e946.svg";